// extracted by mini-css-extract-plugin
export default {"sec1":"Index_sec1__39X6y","sec2":"Index_sec2__mHu9M","gallery":"Index_gallery__p1eu3"};